/** @typedef {import('../domain/types.js').BehavioralCategory} BehavioralCategory */

/**
 * Display groups for App Library (View B). Multiple Lockbox categories can map to one UI group.
 * @type {Array<{ id: string, emoji: string, title: string, categories: BehavioralCategory[], hint: string }>}
 */
export const LIBRARY_CATEGORY_GROUPS = [
  {
    id: "manga_comics",
    emoji: "📚",
    title: "Manga & Comics",
    categories: ["manga_reading", "anime_streaming"],
    hint: "Toomics · Webtoon · Manta · Crunchyroll",
  },
  {
    id: "shortform_social",
    emoji: "📱",
    title: "Short-form & Social",
    categories: ["shortform_feed"],
    hint: "TikTok · Instagram · Reels",
  },
  {
    id: "productivity_comms",
    emoji: "💼",
    title: "Productivity & Comms",
    categories: ["productivity", "work_comms", "learning", "banking", "navigation", "utility"],
    hint: "Notion · Slack · WhatsApp · Maps",
  },
  {
    id: "gaming_entertainment",
    emoji: "🎮",
    title: "Gaming & Entertainment",
    categories: ["gaming_session", "entertainment_discovery"],
    hint: "Games · Netflix · Spotify",
  },
  {
    id: "other",
    emoji: "📦",
    title: "Other",
    categories: ["unknown"],
    hint: "Unclassified apps",
  },
];

/**
 * @param {BehavioralCategory} category
 * @returns {typeof LIBRARY_CATEGORY_GROUPS[number]}
 */
export function groupForCategory(category) {
  return (
    LIBRARY_CATEGORY_GROUPS.find((g) => g.categories.includes(category)) ||
    LIBRARY_CATEGORY_GROUPS.find((g) => g.id === "other")
  );
}
